import { Box, Button, Divider } from "@mui/material";
import Timeline, { type TimelineItem } from "../timeline/Timeline";
import Modal from "./Modal";

interface ModalTimelineProps {
  isOpen: boolean;
  onClose: () => void;
  items: TimelineItem[];
  title?: string;
  entityName?: string;
}

export default function ModalTimeline({
  isOpen,
  onClose,
  items,
  title,
  entityName,
}: ModalTimelineProps) {
  const modalTitle = title || (entityName ? `Historial de cambios - ${entityName}` : "Historial de cambios");

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title={modalTitle}
      content={
        <>
          <Divider />
          <Timeline items={items} />
          <Divider sx={{ marginTop: 2 }} />
          <Box display="flex" gap={2} p={2} justifyContent="flex-end">
            <Button onClick={onClose} variant="contained">
              Cerrar
            </Button>
          </Box>
        </>
      }
      sx={{
        marginX: "auto",
        width: {
          xs: "90%",
          sm: "70%",
          md: "60%",
        },
        maxWidth: 800,
      }}
    />
  );
}
